<template>
  <StdPageContainer type="list">
    <template slot="title">
      <!-- 标题栏 -->
      <StdPageTitle :title="$t('lang.k_394001')"></StdPageTitle>
    </template>
    <!-- 内容区 -->
    <template slot="content">
      <section class="null-data" v-if="list && list.length == 0 && !isSearch">
        <StdNullPage :text="$t('lang.k_394002')" :nullType="'nullData'"></StdNullPage>
      </section>
      <template v-else-if="list">
        <StdSearchBar
          v-model="searchForm.name"
          :placeholder="$t('lang.k_394003')"
          @search="handleCurrentChange(1)"
        ></StdSearchBar>
        <vh-table :data="list" class="trash-list">
          <vh-table-column :label="$t('lang.k_394004')">
            <template slot-scope="scope">
              <vh-tooltip
                placement="top"
                :disabled="!isTextOverflow"
                :content="scope.row.resource_name"
              >
                <div class="videoName custom-tooltip-content">
                  <i
                    class="iconfont-v3 saasshipinwenjian media-icon"
                    v-if="scope.row.resource_type == 1"
                  ></i>
                  {{ scope.row.resource_name || '- -' }}
                </div>
              </vh-tooltip>
            </template>
          </vh-table-column>
          <vh-table-column :label="$t('lang.k_394005')">
            <template slot-scope="scope">
              <span>{{ scope.row.delete_time }}</span>
            </template>
          </vh-table-column>
          <vh-table-column :label="$t('lang.k_394006')">
            <template slot-scope="scope">
              <span>{{ scope.row.expire_time }}</span>
            </template>
          </vh-table-column>
          <vh-table-column :label="$t('lang.k_394007')" width="100">
            <template slot-scope="scope">
              <span>{{ $t('lang.k_394008') }}</span>
            </template>
          </vh-table-column>
          <vh-table-column :label="$t('lang.k_394009')" width="100">
            <template slot-scope="scope">
              <vh-button type="text" @click="handleRestore(scope.row)">
                {{ $t('lang.k_394010') }}
              </vh-button>
            </template>
          </vh-table-column>
          <template slot="empty">
            <StdNullPage :nullType="'search'"></StdNullPage>
          </template>
        </vh-table>
        <StdPagination
          :total="total || 0"
          :page-size="searchForm.limit"
          :currentPage="searchForm.pageNo"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </template>
  </StdPageContainer>
</template>
<script>
  import {
    StdPageContainer,
    StdPageTitle,
    StdNullPage,
    StdPagination,
    StdSearchBar
  } from '@vhcl/ui-console';
  import tableCellTooltip from '@/components/TableList/mixins/tableCellTooltip';
  export default {
    name: 'Trash',
    mixins: [tableCellTooltip],
    components: {
      StdPageContainer,
      StdPageTitle,
      StdNullPage,
      StdSearchBar
    },
    data() {
      return {
        list: '',
        total: 0,
        searchForm: {
          name: '',
          limit: 10,
          pageNo: 1
        },
        isSearch: false
      };
    },
    created() {
      this.handleCurrentChange(1);
      this.toast = this.$vhMessage({
        message: this.$t('lang.k_394011'),
        type: 'warning',
        duration: 0,
        showClose: true
      });
    },
    beforeDestroy() {
      this.toast.close();
    },
    methods: {
      handleCurrentChange(page) {
        this.searchForm.pageNo = page;
        this.getTableList();
      },
      handleSizeChange(limit) {
        this.searchForm.limit = limit;
        this.searchForm.pageNo = 1;
        this.getTableList();
      },
      getTableList() {
        const params = {
          limit: this.searchForm.limit,
          pos: (this.searchForm.pageNo - 1) * this.searchForm.limit,
          resource_type: 1, // 1:音视频
          resource_name: this.searchForm.name
        };
        this.isSearch = params.resource_name ? true : false;
        this.$fetch('gitTrashList', params).then(res => {
          if (res.code == 200) {
            this.list = res.data.list;
            this.total = res.data.total;
          }
        });
      },
      handleRestore(row) {
        this.$confirm(this.$t('lang.k_394012'), this.$t('lang.k_394013'), {
          confirmButtonText: this.$t('lang.k_394014'),
          cancelButtonText: this.$t('lang.k_394015'),
          roundButton: true
        }).then(() => {
          this.$fetch('recoverTrash', { id: row.id }).then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(this.$t('lang.k_394016'));
              this.getTableList();
            } else {
              this.$vhMessage.error(res.msg);
            }
          });
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  .null-data {
    min-height: calc(100vh - 240px);
    position: relative;
    background: #fff;
  }
  .trash-list {
    .media-icon {
      color: #ff733c;
    }
  }
</style>
